import axiosSetup from "../../utils/axiosSetup"; // Keep your import
import { CreateTransferPayload } from "../../store/slices/StockTransfer/stockTransferSlice";
import ResponseModel from "../../models/response.model";

const getbaseUrl = (isMaterial: boolean) =>
  isMaterial ? "/material-stock-transfer" : "/stock-transfer";

export const createStockTransferApi = async (
  payload: CreateTransferPayload,
  isMaterial = false,
) => {
  try {
    const res = await axiosSetup.post(
      `${getbaseUrl(isMaterial)}/create`,
      payload,
    );
    return res.data.data;
  } catch (error: any) {
    throw error;
  }
};

export const acceptStockTransferApi = async (
  items: Array<{ transferId: string; remark?: string }>,
  isMaterial = false,
) => {
  try {
    const res = await axiosSetup.post(`${getbaseUrl(isMaterial)}/accept`, {
      transfers: items,
    });
    return res.data.data;
  } catch (error: any) {
    throw error;
  }
};

export const cancelStockTransferApi = async (
  items: Array<{ transferId: string; remark?: string }>,
  isMaterial = false,
) => {
  try {
    const res = await axiosSetup.post(`${getbaseUrl(isMaterial)}/cancel`, {
      transfers: items,
    });
    return res.data.data;
  } catch (error: any) {
    throw error;
  }
};

export const fetchPendingIncomingTransfersApi = async (
  page = 1,
  limit = 10,
  isMaterial = false,
) => {
  const res = await axiosSetup.get(
    `${getbaseUrl(isMaterial)}/pending-incoming?page=${page}&limit=${limit}`,
  );
  return res.data.data;
};

export const fetchPendingOutgoingTransfersApi = async (
  page = 1,
  limit = 10,
  isMaterial = false,
) => {
  const res = await axiosSetup.get(
    `${getbaseUrl(isMaterial)}/pending-outgoing?page=${page}&limit=${limit}`,
  );
  return res.data.data;
};

export const fetchIncomingSerialsApi = async (isMaterial = false) => {
  const response = await axiosSetup.get(
    `${getbaseUrl(isMaterial)}/pending-incoming-serials`,
  );
  return response.data;
};

export const fetchOutgoingSerialsApi = async (isMaterial = false) => {
  const response = await axiosSetup.get(
    `${getbaseUrl(isMaterial)}/pending-outgoing-serials`,
  );
  return response.data;
};

export const fetchAvailableProductionUnitsApi = async (query?: {
  search?: string;
  page?: number;
  limit?: number;
}): Promise<ResponseModel> => {
  const response = await axiosSetup.get(
    `${getbaseUrl(false)}/available-production-units`,
    { params: query },
  );
  return response.data;
};

export const getMaterialsApi = async (
  usageType: "warehouse" | "factory",
  page: number,
  limit: number,
  search?: string,
) => {
  const response = await axiosSetup.get(`${getbaseUrl(true)}/materials`, {
    params: { usageType, page, limit, search },
  });
  return response.data;
};
